import { LOG_SERVICE } from '@common/services/log/log.service.interface';
import React, { ErrorInfo } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { container } from 'tsyringe';

type Props = WithTranslation & { children: React.ReactNode };
type State = { hasError: boolean };

class ErrorBoundaryApp extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    container.resolve(LOG_SERVICE).captureError(
      error,
      {
        componentStack: errorInfo.componentStack,
        digest: errorInfo.digest,
      },
      { source: 'error-boundary' },
    );
  }

  render() {
    const { children, t } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div>
          <h1>{t('error.generic.title')}</h1>
          <p>{t('error.generic.description')}</p>
          <button
            data-testid="reload-button"
            onClick={() => window.location.reload()}
            type="button"
          >
            {t('error.generic.action')}
          </button>
        </div>
      );
    }

    return children;
  }
}

export default withTranslation()(ErrorBoundaryApp);
